import SharedIntegrated from '../../shared-integrated';

SharedIntegrated.setGlobal(window);
window.onGoogleLibraryLoad = async () => {
    const Integrated = await import('./integrated.js');
    Integrated.setGlobal();
    const isWeb = !Mutil.isMobile() && !Mutil.isTablet();
    if(!isWeb) {
        return;
    }
    GoogleLogin.loadOneTab();
}
